var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3755",
    "data-name": "Rectangle 3755",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4726",
    "data-name": "Mask Group 4726",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8303",
    "data-name": "Group 8303",
    transform: "translate(63.5 482.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8475",
    "data-name": "Group 8475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10979",
    "data-name": "Path 10979",
    d: "M20,35.672V32.186a2.656,2.656,0,0,1,2.656-2.656h5.412m-1.76-.033V27.824a2.279,2.279,0,0,0-2.279-2.279h-.422a2.279,2.279,0,0,0-2.279,2.279v1.8M23.785,20a1.594,1.594,0,1,0,1.594,1.594A1.594,1.594,0,0,0,23.785,20Z",
    transform: "translate(-19.336 -19.336)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "rgb(158, 158, 158)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10980",
    "data-name": "Path 10980",
    d: "M346.98,189.279A2.279,2.279,0,0,0,344.7,187h-.422A2.279,2.279,0,0,0,342,189.279v2.8a7.055,7.055,0,0,1,1.2,4.27.823.823,0,0,0,.847.777h.895a.823.823,0,0,0,.847-.777,7.055,7.055,0,0,1,1.2-4.27Z",
    transform: "translate(-330.645 -180.791)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "rgb(158, 158, 158)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_544",
    "data-name": "Ellipse 544",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(12.5 0.5)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    style: {
      stroke: "rgb(158, 158, 158)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/Customer_icon.b6eaad4fa8350bd986d5e2363def7b3d.svg";
export { ForwardRef as ReactComponent };